export const Colors = {
    background: '#fffcf4',
    tint: '#1d4772',
    awcOrange: '#AF2501',
    backgroundLow: '#eee',
    divider: '#4B3B40',
    bodyText: '#4B3B40',
    positive: '#5AA393'

}